module.exports = __webpack_public_path__ + "static/img/how-to-create_en.4c776033.gif";